import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, useTheme } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { HtmlTooltip } from "components/HeatMap";
import { appendTooltipGlossary } from "components/reports/shared/tooltipGlossary";

const DashboardCardHeader = ({
  title,
  tooltipTitle,
  tooltipContent,
  titleVariant = "h6",
  titleColor,
  titleSx,
}) => {
  const theme = useTheme();
  const resolvedTooltipContent = appendTooltipGlossary(tooltipContent);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
      <Typography
        variant={titleVariant}
        sx={{
          fontWeight: 700,
          color: titleColor || theme.palette.text.primary,
          minWidth: 0,
          ...titleSx,
        }}
      >
        {title}
      </Typography>
      {resolvedTooltipContent && (
        <HtmlTooltip
          title={
            <Box sx={{ p: 1, maxHeight: "400px", overflowY: "auto" }}>
              {tooltipTitle && (
                <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                  {tooltipTitle}
                </Typography>
              )}
              <Typography variant="body2" sx={{ whiteSpace: "pre-line" }}>
                {resolvedTooltipContent}
              </Typography>
            </Box>
          }
          arrow
          placement="bottom-start"
        >
          <InfoOutlined
            sx={{
              fontSize: 18,
              color: theme.palette.primary.main,
              cursor: "help",
              opacity: 0.7,
              flexShrink: 0,
              "&:hover": {
                opacity: 1,
              },
            }}
          />
        </HtmlTooltip>
      )}
    </Box>
  );
};

DashboardCardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.string,
  tooltipContent: PropTypes.string,
  titleVariant: PropTypes.string,
  titleColor: PropTypes.string,
  titleSx: PropTypes.object,
};

export default DashboardCardHeader;